import { CONSTANTS } from 'services/constants';
import QueryBuilder from 'services/repositories/QueryBuilder';
import HttpClient from '../http/HttpClient';

export default class BaseRepository
{
    constructor()
    {
        this.httpClient = new HttpClient();
    }

    // <editor-fold desc="Abstract">

    getEndpoint()
    {
        throw new Error('Method [getEndpoint] must be overwritten by child class');
    }

    // </editor-fold>

    /**
     *
     * @param data
     * @returns {Promise<HttpResponse>}
     */
    add(data)
    {
        return this.request('POST', this.getEndpoint(), data);
    }

    /**
     * All
     * @param queryBuilder
     * @returns {Promise<HttpResponse>}
     */
    all(queryBuilder = null)
    {
        let queryString = '';

        if (queryBuilder)
        {
            queryString = this.buildQueryString(queryBuilder.buildQuery());
        }

        return this.request('GET', `${this.getEndpoint()}?${queryString}`);
    }

    /**
     *
     * @param data
     * @param entityId
     * @returns {Promise<HttpResponse>}
     */
    edit(data, entityId = null)
    {
        let finalId = entityId;
        if (finalId === null)
        {
            const { id } = data;
            finalId = id;
        }

        if (!finalId)
        {
            throw new Error('In order to edit a record, an id must be provided');
        }

        return this.request('PATCH', `${this.getEndpoint()}/${finalId}`, data);
    }

    /**
     *
     * @param id
     * @param includes
     * @returns {Promise<HttpResponse>}
     */
    find(id, includes = null)
    {
        return this.request('GET', `${this.getEndpoint()}/${id}?${this.buildQueryString({ includes })}`);
    }

    /**
     *
     * @param method
     * @param url
     * @param data
     * @returns {Promise<HttpResponse>}
     */
    request(method, url, data)
    {
        return this.httpClient.request(method, url, data);
    }

    /**
     *
     * @param data
     * @returns {Promise<HttpResponse>}
     */
    save(data)
    {
        if (data.id && data.id !== CONSTANTS.DATA.NEW_ID) return this.edit(data);

        return this.add(data);
    }

    /**
     * Query
     * @returns {QueryBuilder}
     */
    query()
    {
        return new QueryBuilder(this.all);
    }

    /**
     *
     * @param payload
     * @param prefix
     * @returns {string}
     */
    buildQueryString(payload, prefix)
    {
        const str = [];

        Object.keys(payload).forEach((key) =>
        {
            const k = prefix ? `${prefix}[${key}]` : key;
            const v = payload[key] === null ? '' : payload[key];

            str.push((v !== null && typeof v === 'object')
                ? this.buildQueryString(v, k)
                : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
        });

        return str.join('&');
    }
}
